import { render, staticRenderFns } from "./SelDashboard.vue?vue&type=template&id=51298e20&scoped=true&"
import script from "./SelDashboard.vue?vue&type=script&lang=js&"
export * from "./SelDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SelDashboard.vue?vue&type=style&index=0&id=51298e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51298e20",
  null
  
)

export default component.exports